export default __webpack_public_path__ + "static/media/28.5f6143d6.png";